export const MESSAGE_ROW_DATA_ATTRIBUTE = "data-message-id";

export function messageRowDataAttribute(messageId: string): Record<string, string> {
  return { [MESSAGE_ROW_DATA_ATTRIBUTE]: messageId };
}

export function findMessageRowElement(
  scrollContainer: HTMLElement,
  messageId: string,
): HTMLElement | null {
  return scrollContainer.querySelector<HTMLElement>(
    `[${MESSAGE_ROW_DATA_ATTRIBUTE}="${messageId}"]`,
  );
}

export function scrollMessageRowIntoView(
  scrollContainer: HTMLElement,
  messageId: string,
): HTMLElement | null {
  const row = findMessageRowElement(scrollContainer, messageId);
  if (!row) {
    return null;
  }
  row.scrollIntoView({ behavior: "smooth", block: "center" });
  return row;
}

export type QuotedMessageSeekPlan = "already-loaded" | "load-older" | "unavailable";

export function quotedMessageSeekPlan(input: {
  isLoaded: boolean;
  hasOlderPages: boolean;
}): QuotedMessageSeekPlan {
  if (input.isLoaded) {
    return "already-loaded";
  }
  if (input.hasOlderPages) {
    return "load-older";
  }
  return "unavailable";
}
